import axios from 'axios';

const getBaseURL = () => {
  const { hostname, origin } = window.location;
  if (hostname === 'localhost' || hostname === '127.0.0.1') return 'http://127.0.0.1:8000/api';
  return `${origin}/api`;
};

const api = axios.create({
  baseURL: getBaseURL(),
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

// 🌟 REQUEST INTERCEPTOR: Har API call me token lagayega
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('candidateToken') || localStorage.getItem('admin_token') || localStorage.getItem('employer_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => Promise.reject(error));

// 🌟 RESPONSE INTERCEPTOR: Fail hone par hi redirect karega
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const path = window.location.pathname;
    if (error.response && error.response.status === 401) {
      if (path.includes('/admin') && path !== '/admin/login') {
        localStorage.removeItem('admin_token');
        window.location.href = '/admin/login';
      } else if (path.includes('/candidate') || path.includes('/employer')) {
        localStorage.removeItem('candidateToken');
        localStorage.removeItem('candidate');
        window.location.href = '/';
      }
    }
    return Promise.reject(error);
  }
);

export const STORAGE_URL = (path) => {
  if (!path) return '';
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  const { hostname, origin } = window.location;
  if (hostname === 'localhost' || hostname === '127.0.0.1') return `http://127.0.0.1:8000/storage/${path}`;
  return `${origin}/api/storage/${path}`;
};

export default api;